<template>
  <Wrapper>
    <div class="blank" v-if="!isInfoLang"></div>
    <main class="main" v-else>
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}` }"
            class="breadcrumb-trail__list--item__link"
          >
            TOP
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}notice`, query: { id: noticeParam } }"
            class="breadcrumb-trail__list--item__link"
            v-html="NoticeList.items[noticeParam - 1].title[lang]"
          >
          </router-link>
        </li>
      </ol>
      <h1
        class="page-title"
        v-html="NoticeList.items[noticeParam - 1].title[lang]"
      ></h1>
      <section class="sentence-section">
        <p
          class="notice-sentence"
          v-html="NoticeList.items[noticeParam - 1].body[lang]"
        ></p>
      </section>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/sp/Wrapper";
export default {
  data() {
    return {
      noticeParam: -1,
      isInfoLang: false,
      NoticeList: {
        items: [
          {
            id: 1,
            time: "2020/12/26",
            title: {
              ja: "<span style='color:red;'>【重要】</span>開催日までに必ずアプリ連携をお済ませください！",
              en: "<span style='color:red;'>【重要】</span>開催日までに必ずアプリ連携をお済ませください！"
            },
            body: {
              ja: "2020年12月26日開催 RUN as ONE - GLOBAL Virtual Run Series 2020/2021 1st Challengeにエントリーされている方で、\nアプリ連携設定がお済みでない方へのお知らせとなります。\n\n＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝\n\n必ず、開催までに連携設定をお願いします！\n\n＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝\n\n<span style='color:red'>アプリ連携をされていない場合には、参加料をお支払いいただいていましても、\nランキングへの反映及び、RUN as ONE - Tokyo Marathon 2022（一般）出走権の抽選対象となりませんので、ご注意ください。</span>\n\n※アプリ連携設定までの手順は<a href='https://tmf-virtualrun.jp/pdf/vartualrun_flow_01.pdf' target='_blank' rel=\"noopener\" class='t-underline'>こちら</a>\n※アプリ連携がされているかどうかを確認するには<a href='https://tmf-virtualrun.jp/pdf/vartualrun_flow_02.pdf' target='_blank' rel=\"noopener\" class='t-underline'>こちら</a>",
              en: "2020年12月26日開催 RUN as ONE - GLOBAL Virtual Run Series 2020/2021 1st Challengeにエントリーされている方で、\nアプリ連携設定がお済みでない方へのお知らせとなります。\n\n＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝\n\n必ず、開催までに連携設定をお願いします！\n\n＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝\n\n<span style='color:red'>アプリ連携をされていない場合には、参加料をお支払いいただいていましても、\nランキングへの反映及び、RUN as ONE - Tokyo Marathon 2022（一般）出走権の抽選対象となりませんので、ご注意ください。</span>\n\n※アプリ連携設定までの手順は<a href='https://tmf-virtualrun.jp/pdf/vartualrun_flow_01.pdf' target='_blank' rel=\"noopener\" class='t-underline'>こちら</a>\n※アプリ連携がされているかどうかを確認するには<a href='https://tmf-virtualrun.jp/pdf/vartualrun_flow_02.pdf' target='_blank' rel=\"noopener\" class='t-underline'>こちら</a>"
            },
          },
          {
            id: 2,
            time: "2021/12/30",
            title: {
              ja: "【1st Challenge のランキング確定 】RUN as ONE - GLOBAL Virtual Run\nSeries 2020/2021",
              en: "【Opening of English Page】English page is Now Available!"
            },
            body: {
              ja: "2020年12月26日開催 RUN as ONE - GLOBAL Virtual Run Series 2020/2021 1st Challengeにエントリーされている方で、\\nアプリ連携設定がお済みでない方へのお知らせとなります。\\n\\n＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝\\n\\n必ず、開催までに連携設定をお願いします！\\n\\n＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝\\n\\n<span style='color:red'>アプリ連携をされていない場合には、参加料をお支払いいただいていましても、\\nランキングへの反映及び、RUN as ONE - Tokyo Marathon 2022（一般）出走権の抽選対象となりませんので、ご注意ください。</span>\\n\\n※アプリ連携設定までの手順は<a href='https://tmf-virtualrun.jp/pdf/vartualrun_flow_01.pdf' target='_blank' rel=\"noopener\" class='t-underline'>こちら</a>\\n※アプリ連携がされているかどうかを確認するには<a href='https://tmf-virtualrun.jp/pdf/vartualrun_flow_02.pdf' target='_blank' rel=\"noopener\" class='t-underline'>こちら</a>",
              en: "Welcome and thank you for visiting the TMF VIRTUAL RUN webpage.\nThe official webpage is now available in Japanese and English, and we look forward to your entry and connecting to more runners around the world."
            },
          },
          {
            id: 3,
            time: "2021/01/07",
            title: {
              ja: "【1st Challenge 抽選について 】RUN as ONE - GLOBAL Virtual Run\nSeries 2020/2021 Series 2020/2021",
              en: "【Important】Make Sure to Sync your Downloaded App to the Event."
            },
            body: {
              ja: "このたびは、RUN as ONE GLOBAL Virtual Run Series 2020/2021 1St Challengeへ参加ありがとうございました。\n一部の方のデータが反映されない事象が発生したため、今回に限り参加者（2,978名）を抽選対象とさせていただきました。何卒ご理解いただきますよう、よろしくお願いします。\nなお、厳正なる抽選結果は、キリ番当選者と合わせて50名を1/8（金）12:00に発表させていただきます",
              en: "We are noticing that many of our participants are not properly syncing their app to the event they entered.\nIn order to participate in the event, you must sync your app to each event.　\n*Note, you must sync your app per event, even if you are entering to multiple events at the same time.\nTo learn the process, click <a href='https://tmf-virtualrun.jp/pdf/flow/vartualrun_flow01_revised_en.pdf' target='_blank' rel=\"noopener\" class='t-underline'>here</a> or view our <a href='https://tmf-virtualrun.jp/en/howtojoin' class='t-underline'>\"How to Join\"</a> page."
            },
          },
          {
            id: 4,
            time: "2021/01/08",
            title: {
              ja: "【2nd Challenge エントリー延期について 】RUN as ONE - GLOBAL Virtual Run\nSeries 2020/2021 Series 2020/2021",
              en: "【ROAD TO TOKYO MARATHON】Entry Opening Soon.."
            },
            body: {
              ja: "来週1月12日（火）からエントリー開始の予定しておりましたが、\n政府からの緊急事態宣言発令に伴い、エントリー開始日を延期することにいたしました。\nエントリー開始日等、決まり次第ご案内いたします",
              en: "Entry to the ROAD TO TOKYO MARATHON has changed.\nFor more information, click <a href='https://www.marathon.tokyo/en/events/rttm/' class='t-underline' target='_blank' rel='noopener'>here.</a>"
            },
          },
          {
            id: 5,
            time: "2021/02/22",
            title: {
              ja: "【RUN as ONE - GLOBAL Virtual Run Series 2020/2021 2nd Challenge】ランキング確定について",
              en: "【Important】Make Sure to Sync your Downloaded App to the Event."
            },
            body: {
              ja: "本日（2/22）ランキング確定を予定としておりましたが、最終確定までもうしばらくお時間がかかります。\n発表を心待ちにしていただいている皆様、お待たせして大変申し訳ございません。\nランキングが確定次第、お知らせいたします。",
              en: "We are noticing that many of our participants are not properly syncing their app to the event they entered. \nIn order to participate in the event, you must sync your app to each event.\n*Note, you must sync your app per event, even if you are entering multiple events at the same time. \nTo learn the process, click <a href='https://tmf-virtualrun.jp/pdf/flow/vartualrun_flow01_revised_en.pdf' class='t-underline' target='_blank' rel='noopener'>here</a> or view our <a href='https://tmf-virtualrun.jp/en/howtojoin' class='t-underline' target='_blank' rel='noopener'>'How to Join'</a> page."
            },
          },
          {
            id: 6,
            time: "2021/03/01",
            title: {
              ja: "【ROAD TO TOKYO MARATHON 2021 Virtual ONE TOKYO Premium】ランキング確定について",
              en: "【Important】Make Sure to Sync your Downloaded App to the Event."
            },
            body: {
              ja: "本日（3/1）ランキング確定とご案内しておりましたが、最終確定までもうしばらくお時間がかかります。\n発表を心待ちにしていただいている皆様、お待たせして大変申し訳ございません。\nランキングが確定次第、お知らせいたします。",
              en: "We are noticing that many of our participants are not properly syncing their app to the event they entered. \nIn order to participate in the event, you must sync your app to each event.\n*Note, you must sync your app per event, even if you are entering multiple events at the same time. \nTo learn the process, click <a href='https://tmf-virtualrun.jp/pdf/flow/vartualrun_flow01_revised_en.pdf' class='t-underline' target='_blank' rel='noopener'>here</a> or view our <a href='https://tmf-virtualrun.jp/en/howtojoin' class='t-underline' target='_blank' rel='noopener'>'How to Join'</a> page."
            },
          },
          {
            id: 7,
            time: "2021/03/08",
            title: {
              ja: "ROAD TO TOKYO MARATHON 2021 Virtual MARATHON/ HALF/ 10K にご参加いただいたランナーの皆さまへ",
              en: "To all participants of the ROAD TO TOKYO MARATHON 2021 Virtual MARATHON/ HALF/ 10K"
            },
            body: {
              ja: "システムへの負荷増加に伴い不具合が発生したため、ランデータがランキングに反映されていない方がいらっしゃいます。\nご参加いただいた皆さまには、大変ご迷惑をおかけいたしますが、順次ランデータの取り込み作業を行っておりますので、ランキング反映まで今しばらくお待ちいただきますようお願いいたします。\nまた、完走を証明できるランデータの提出期限に関しては、3月8日(月)23:59としておりましたが、期間を延長したうえでランキング確定後に改めてご案内させていただきます。\nご迷惑をおかけして大変申し訳ありませんが、ご理解のほどよろしくお願いいたします。",
              en: "We recognize that many of the records of our participants are not reflecting in our ranking system due to a system error.\nWe would like to sincerely apologize to all who are experiencing the problem. We are working on fixing the issue and we would like to request a little more of your time until your record uploads in to our system.\nInitially, 11:59 p.m. on March 8 (JST) was the deadline to submit your proof of record, but we will extend the date and we will let you know separately when the new deadline is decided.\nPlease do not feel rushed to submit your record and we are truly sorry that we are not responding in promptly manner and we would like to request your patience in advance if you do not hear from us right away.\nThank you very much for your understanding."
            },
          },
          {
            id: 8,
            time: "2025/08/28",
            title: {
              ja: "システムメンテナンスのご連絡",
              en: "",
            },
            body: {
              ja: "平素は、TMF VIRTUAL RUNをご利用いただき、誠にありがとうございます。<br><br>下記日程にて、システムメンテナンスを実施いたします。<br><br>■作業日時<br>2025年8月31日(日) 0:00～4:00<br>※メンテナンス時間は作業進捗により、前後する場合がございます。<br><br>上記時間帯におきまして、10分程度エントリーページにアクセスできない状況が発生いたします。ページが開かない場合には、時間をおいて改めてアクセスしていただきますようお願いいたします。<br><br>ご不便をおかけいたしますが、何卒ご理解いただきますようお願い申し上げます。",
              en: "",
            },
          },
          {
            id: 9,
            time: "2024/12/5",
            title: {
              ja: "東京メトロ×大塚製薬「銀座線の路線距離を走ろう！ バーチャルマラソン2024」",
              en: "",
            },
            body: {
              ja: "東京マラソンオフィシャルパートナーの東京地下鉄株式会社と大塚製薬株式会社のコラボ企画としてバーチャルランを活用した、「銀座線の路線距離14.2kmを走ろう! バーチャルマラソン2024」を開催します。<br><br>銀座線の走行距離である14.2kmの走行にかかったタイムを、エントリーした東京メトロ各路線チーム内の参加者同士で競うイベントです。ぜひ楽しみながら奮ってご参加ください。<br>エントリーは<a href='https://tmf-virtualrun.jp/event/0000000084' class='t-underline' target='_blank' rel='noopener'>こちら</a><br>ランキングは<a href='https://tmf-virtualrun.jp/company/ranking?event=1000000006&page=1' class='t-underline' target='_blank' rel='noopener'>こちら</a><br><br><a href='https://tmf-virtualrun.jp/company/ranking?event=1000000006&page=1' target='_blank' rel='noopener'><img src='https://tmf-virtualrun.jp/images/ginzaline-1.PNG' width='100%'></a><br>",
              en: "",
            },
          },
          {
            id: 10,
            time: "2025/6/5",
            title: {
              ja: "ファミリー陸上★チャレンジDAYS！！",
              en: "",
            },
            body: {
              ja: "この夏、東京で世界陸上が開催。<br>夏休みの期間中、バーチャルランで一緒に盛り上がりませんか!?<br>自分の好きな時間、好きな場所で参加OK。親子でも個人でも参加可能です！<br><br><img src='https://tmf-virtualrun.jp/images/notice/family_rikujo_2025_7.jpg' width='100%'><br><br>「お子様＋保護者のペア」でご参加できる種目と、「高校生以下の個人」で参加できる2種目！<br>東京2025世界陸上のペアチケットや国立競技場でのイベント参加権など特典も盛りだくさん！<br><br>①「ファミリーの部（お子様＋保護者のペア）」のエントリーは<a href='https://tmf-virtualrun.jp/event/0000000096' class='t-underline' target='_blank' rel='noopener'>こちら</a><br>　 「ファミリーの部（お子様＋保護者のペア）」のリザルトは<a href='https://tmf-virtualrun.jp/company/ranking?event=1000000009&page=1' class='t-underline' target='_blank' rel='noopener'>こちら</a><br>②「個人の部（高校生以下）」のエントリーは<a href='https://tmf-virtualrun.jp/event/0000000097' class='t-underline' target='_blank' rel='noopener'>こちら</a><br>　 「個人の部（高校生以下）」のリザルトは<a href='https://tmf-virtualrun.jp/ranking?event=0000000097&page=1' class='t-underline' target='_blank' rel='noopener'>こちら</a><br><br><img src='https://tmf-virtualrun.jp/images/notice/family_rikujo_2025_8.png' width='100%'>",
              en: "",
            },
          },
          {
            id: 11,
            time: "2025/6/5",
            title: {
              ja: "VIRTUAL RUNS：INTO KK",
              en: "",
            },
            body: {
              ja: "2025年秋に開催される東京2025世界陸上へ向けてバーチャルランイベントを開催します！<br>いつでもどこでも自由に、みんなで走って東京2025世界陸上を盛り上げよう!!<br><br>完走者の中から抽選で東京2025世界陸上の前日にKK線を走る限定イベント「RUNS：INTO KK」でのハーフリレーマラソンに参加することができます。<br><br>「VIRTUAL RUNS：INTO KK」のエントリーは<a href='https://tmf-virtualrun.jp/event/0000000095' class='t-underline' target='_blank' rel='noopener'>こちら</a><br>「VIRTUAL RUNS：INTO KK」のリザルトは<a href='https://tmf-virtualrun.jp/ranking?event=0000000095&page=1' class='t-underline' target='_blank' rel='noopener'>こちら</a><br><br><a href='https://runsintokk.com/' target='_blank' rel='noopener'><img src='https://tmf-virtualrun.jp/images/notice/vitual_runs_into_kk_2025.png' width='100%'></a>",
              en: "",
            },
          },
          {
            id: 12,
            time: "2026/1/8",
            title: {
              ja: "東京メトロバーチャルマラソン　半蔵門線の路線距離を走ろう！",
              en: "",
            },
            body: {
              ja: "東京マラソンオフィシャルパートナーの東京地下鉄株式会社とのコラボ企画として、バーチャルランを活用した、「東京メトロバーチャルマラソン　半蔵門線の路線距離を走ろう！」を開催します。<br><br>半蔵門線の路線距離である16.8kmの走行にかかったタイムを、エントリーした東京メトロ各路線グループ内のランナー同士で競うイベントです。<br>ぜひ楽しみながら奮ってご参加ください。<br>エントリーは<a href='https://tmf-virtualrun.jp/event/0000000111' class='t-underline' target='_blank' rel='noopener'>こちら</a><br><br><a href='https://tmf-virtualrun.jp/event/0000000111' target='_blank' rel='noopener'><img src='https://tmf-virtualrun.jp/images/metro_hazomon.png' width='100%'></a>",
              en: "",
            },
          },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.noticeParam = this.$route.query.id;
    }
    if (this.NoticeList.items[this.noticeParam - 1].title[this.lang]) {
      this.isInfoLang = true;
    }
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
  },
  name: "NoticeDetail",
};
</script>

<style scoped>
.main {
  .page-title {
    margin: 40px 0 0 0;
    line-height: 1.25;
    padding: 0 0 0 15px;
    border-left: solid 8px var(--defaultBlackColor);
    font-size: 32px;
    font-weight: 900;
  }

  .sentence-section {
    margin: 40px 0 0 0;

    .notice-sentence {
      line-height: 1.6;
      font-size: 14px;
      white-space: pre-line;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/notice/NoticeDetail.vue